const state = {
  type: null,
  data: null,
  callback: () => {},
};

const getters = {};

const actions = {};

const mutations = {
  SHOW_POPUP(state, payload) {
    state.type = payload.type;
    state.data = payload.data;
    state.callback = payload.callback;
  },
  HIDE_POPUP(state) {
    if (state.type && state.data) {
      state.type = null;
      state.data = null;
      state.callback = () => {};
    }
  },
  DELETE_POPUP(state, dialog) {
    Vue.delete(state.dialogs, dialog);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
